import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";

const LegendContext = createContext({});

export const LegendProvider = ({ children }) => {
  const storageKey = "@HubEverlog:legendMode";
  const getInitialLegendMode = () => {
    if (typeof window === "undefined") {
      return false;
    }
    const storedValue = window.localStorage.getItem(storageKey);
    if (storedValue === null) {
      return false;
    }
    return storedValue === "true";
  };

  const [legendMode, setLegendMode] = useState(getInitialLegendMode);

  const setLegend = useCallback((mode) => {
    setLegendMode(mode); // Mantém o nome consistente com o estado
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    window.localStorage.setItem(storageKey, String(legendMode));
  }, [legendMode, storageKey]);

  return (
    <LegendContext.Provider
      value={{
        legendMode,
        setLegend,
      }}
    >
      {children}
    </LegendContext.Provider>
  );
};

export const useLegend = () => {
  const context = useContext(LegendContext);

  if (!context) {
    throw new Error("useLegend must be used within an AuthProvider");
  }
  return context;
};
